const megaMenu = document.querySelectorAll('.mega-menu');
const megaMenuItems = document.querySelectorAll('.mega-menu__modals-item');

megaMenu.forEach((el) => {
  const megaMenuDefault = el.querySelector('.mega-menu__default');

  // Slider Work
  const sliders = {
    top: el.querySelector('[data-slider="mega-menu-top-slider"]'),
    bottom: el.querySelector('[data-slider="mega-menu-bottom-slider"]'),
  };

  const baseOptions = {
    spaceBetween: 10,
    allowTouchMove: false,
    watchOverflow: true,
    speed: 800,
  };

  const topSLider = new Swiper(sliders.top, {
    ...baseOptions,
    direction: 'vertical',
  });

  const bottomSLider = new Swiper(sliders.bottom, {
    ...baseOptions,
    direction: 'horizontal',
  });

  const resetMegaMenu = (speed = 800) => {
    topSLider.slideTo(0, speed);
    bottomSLider.slideTo(0, speed);
    removeActiveClass(megaMenuItems);
  };

  megaMenuItems.forEach((item) => {
    item.addEventListener('mouseenter', (el) => {
      const parentItem = el.target.closest('[data-item]');
      const sliderIndex = parentItem.getAttribute('data-item');
      topSLider.slideTo(sliderIndex);
      bottomSLider.slideTo(sliderIndex);
      removeActiveClass(megaMenuItems);
      el.target.classList.add('is-active');
    });

    // Get Titles Width
    const getTitlesWidth = () => {
      const parentEle = item.querySelector('.mega-menu__modals-header');
      const lastTag = item.querySelector('.mega-menu__modals-tag:last-child');
      const titleEle = item.querySelector('.mega-menu__modals-title-scale');
      if (!parentEle || !lastTag || !titleEle) return;
      parentEle.style.setProperty('--title-width', `${parentEle.offsetWidth - lastTag.offsetWidth}px`);

      setTimeout(() => {
        parentEle.style.setProperty('--title-scale-width', `${titleEle.getBoundingClientRect().width}px`);
      }, 100);
    };

    getTitlesWidth();
    window.addEventListener('resize', getTitlesWidth);
  });

  megaMenuDefault.addEventListener('mouseenter', () => {
    resetMegaMenu();
  });

  attachEvent('.menu__arrow', 'click', () => {
    resetMegaMenu(0);
  });
});
